import React, { Component } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Login from './assets/components/Login'
import Dashboard from './assets/components/Dashboard'
import Customers from './assets/components/Customers'
import Leads from './assets/components/Leads'
import FBLeadManager from './assets/components/FBLeadManager'
import Users from './assets/components/Users'


export class App extends Component {
  render() {
    return (
      <Router>
        <Route path="/" render={props => (<Login />)} exact />
        <Route path="/dashboard" render={props => (<Dashboard />)} />
        <Route path="/customers" render={props => (<Customers />)} />
        <Route path="/leads" render={props => (<Leads />)} />
        <Route path="/fb-lead-manager" render={props => (<FBLeadManager />)} />
        <Route path="/users" render={props => (<Users />)} />
      </Router>
    )
  }
}

export default App

